import React, { lazy } from "react";
import { Redirect } from "react-router";
import { WebUrl } from "../util/Constant";

const Home = lazy(() => import("../pages/home/Home"));
const GameProvider = lazy(() => import("../pages/home/GameProvider"));
const DepositDesktop = lazy(() => import("../pages/reload/Deposit2"));
const Withdrawal2 = lazy(() => import("../pages/home/Withdrawal2"));
const TransactionHistory = lazy(() => import("../pages/home/TransactionHistory"));
const PendingTransaction = lazy(() => import("../pages/home/PendingTransaction"));
const Notification = lazy(() => import("../pages/home/Notification"));
const Downline = lazy(() => import("../pages/downline/Downline"));
const ProgressCommRate = lazy(() => import("../pages/downline/ProgressCommRate"));
const EditDownlineDetails = lazy(() => import("../pages/downline/EditDownlineDetails"));
const DownlineGroupDetail = lazy(() => import("../pages/downline/DownlineGroupDetail"));
const EditDownlineGroupDetail = lazy(() => import("../pages/downline/EditDownlineGroupDetail"));
const Kpi = lazy(() => import("../pages/home/Kpi"));
const Report = lazy(() => import("../pages/home/Report"));
const GameRecordUG = lazy(() => import("../pages/home/GameRecordUG"));
const Statement = lazy(() => import("../pages/home/Statement"));
const WalletStatement = lazy(() => import("../pages/home/WalletStatement"));
const RolloverStatement = lazy(() => import("../pages/home/RolloverStatement"));
const Rewards = lazy(() => import("../pages/home/Rewards"));
const RewardHistory = lazy(() => import("../pages/home/RewardHistory"));
const RewardsTnC = lazy(() => import("../pages/home/RewardsTnC"));
const RegisterNew = lazy(() => import("../pages/RegisterNew"));
const NotificationDetail = lazy(() => import("../pages/home/NotificationDetail"));
const Promotion = lazy(() => import("../pages/home/Promotion"));
const BonusReport = lazy(() => import("../pages/home/BonusReport"));
const DepositBonusHistory = lazy(() => import("../pages/home/DepositBonusHistory"));
const InternalTransferReport = lazy(() => import("../pages/home/InternalTransferReport"));
const Account = lazy(() => import("../pages/home/Account"));
const Settings = lazy(() => import("../pages/home/Settings"));
const Terms = lazy(() => import("../pages/home/TermsAndCondition"));
const About = lazy(() => import("../pages/home/About"));
const VipEvent = lazy(() => import("../pages/vip-event/VipEvent"));
const SummaryDownline = lazy(() => import("../pages/vip-event/SummaryDownline"));
const HelpCentre = lazy(() => import("../pages/setting/HelpCentre"));
const HelpCentreCategory = lazy(() => import("../pages/setting/HelpCentreCategory"));
const HelpCentreSubCategory = lazy(() => import("../pages/setting/HelpCentreSubCategory"));
const HelpCentreFaq = lazy(() => import("../pages/setting/HelpCentreFaq"));
const Referral = lazy(() => import("../pages/home/Referral"));
const ReferralCode = lazy(() => import("../pages/home/ReferralCode"));
const ReferralEdit = lazy(() => import("../pages/home/ReferralEdit"));
const DownloadApp = lazy(() => import("../pages/home/DownloadApp"));
const VideoTutorial = lazy(() => import("../pages/home/VideoTutorial"));
const Result = lazy(() => import("../pages/result/4DResult"));
const ContactUs = lazy(() => import("../pages/contact-us/ContactUs"));
const GameList = lazy(() => import("pages/home/GameList"));
const ClaimHistory = lazy(() => import("pages/home/ClaimHistory"));
const ProviderLobby = lazy(() => import("pages/game/ProviderLobby"));
const RichwinAdmin = lazy(() => import("pages/home/RichwinAdmin"));
const CommissionHistory = lazy(() => import("../pages/home/CommissionHistory"));
const MemberProductRateDetail = lazy(() => import("../pages/member/MemberProductRateDetail"));
const UnclaimCommissionHistory = lazy(() => import("../pages/member/UnclaimCommissionHistory"));
const LiveChatPage = lazy(() => import("../pages/contact-us/LiveChat"));
const WalletTransferHistory = lazy(() => import("pages/home/WalletTransferHistory"));
const DepositRecord = lazy(() => import("pages/transaction/DepositRecord"));
const WithdrawalRecord = lazy(() => import("pages/transaction/WithdrawalRecord"));
const LoyaltyRedemption = lazy(() => import("../pages/home/LoyaltyRedemption"));
const LoyaltyRedemptionHistory = lazy(() => import("../pages/home/LoyaltyRedemptionHistory"));
const LoyaltyRedemptionTnC = lazy(() => import("../pages/home/LoyaltyRedemptionTnC"));
const LoyaltyPointsHistory = lazy(() => import("../pages/home/LoyaltyPointsHistory"));
const LoyaltyVoucherDetails = lazy(() => import("../pages/home/LoyaltyVoucherDetails"));
const DailyCheckIn = lazy(() => import("../pages/home/DailyCheckIn"));
const GameProviderList = lazy(() => import("../pages/game/GameProvider"));
const PusatInfo = lazy(() => import("../pages/home/PusatInfo"));
const RegisterSuccess = lazy(() => import("../pages/RegisterSuccess"));
const MyPromo = lazy(() => import("../pages/home/MyPromo"));
const DepositRecordUG = lazy(() => import("../pages/home/DepositRecordUG"));
const WithdrawalRecordUG = lazy(() => import("../pages/home/WithdrawalRecordUG"));
const TransferRecordUG = lazy(() => import("../pages/home/TransferRecordUG"));
const LastTransaction = lazy(() => import("../pages/home/LastTransaction"));
const SpinWheel = lazy(() => import("../pages/member/SpinWheel_New"));
const Congrats = lazy(() => import("../pages/home/Congrats"));
const InactiveDownlines = lazy(() => import("../components/my-profile/InactiveDownlines"));
const TotalCommAndReward = lazy(() => import("../pages/home/TotalCommAndReward"));
const MemberBenefit = lazy(() => import("../pages/home/MemberBenefit"));

/// <summary>
/// Author :
/// </summary>
export const _LOGIN_ROUTE = {
    path: WebUrl._URL_MAIN,
    exact: false,
    authRequired: false,
    component: () => <Redirect to={WebUrl._URL_LOGIN} />,
};

export const _ROUTES = [
    // {
    //   path: WebUrl._URL_MAIN,
    //   exact: true,
    //   authRequired: true,
    //   component: () => <Redirect to={WebUrl._URL_HOME} />,
    // },
    {
        path: "/",
        exact: true,
        authRequired: false,
        component: () => <Redirect to={WebUrl._URL_MAIN} />,
    },
    {
        path: "/home",
        exact: true,
        authRequired: false,
        component: () => <Redirect to={WebUrl._URL_MAIN} />,
    },
    {
        path: "/login",
        exact: true,
        authRequired: false,
        component: () => <Redirect to={WebUrl._URL_MAIN} />,
    },
    {
        path: WebUrl._URL_MAIN,
        exact: true,
        title: "Home",
        authRequired: false,
        component: () => <Home />,
    },
    {
        path: WebUrl._URL_GAME_PROVIDER,
        exact: true,
        title: "Game Provider",
        authRequired: false,
        component: () => <GameProvider />,
    },
    //{
    //    path: WebUrl._URL_MAIN_WALLET,
    //    exact: true,
    //    title: "Main Wallet",
    //    authRequired: true,
    //    component: () => <MainWallet />,
    //},
    {
        path: WebUrl._URL_DEPOSIT,
        exact: true,
        title: "Deposit",
        authRequired: true,
        component: () => <DepositDesktop />,
    },
    {
        path: WebUrl._URL_WITHDRAWAL,
        exact: true,
        title: "Withdrawal",
        authRequired: true,
        component: () => <Withdrawal2 />,
    },
    {
        path: WebUrl._URL_TRANSACTION_HISTORY,
        exact: true,
        title: "Transaction-history",
        authRequired: true,
        component: () => <TransactionHistory />,
    },
    {
        path: WebUrl._URL_PENDING_TRANSACTION,
        exact: true,
        title: "Pending Transaction",
        authRequired: true,
        component: () => <PendingTransaction />,
    },
    //{
    //    path: WebUrl._URL_TRANSFER,
    //    exact: true,
    //    title: "Transfer",
    //    authRequired: true,
    //    component: () => <Transfer />,
    //},
    {
        path: WebUrl._URL_NOTIFICATION,
        exact: true,
        title: "Notification",
        authRequired: true,
        component: () => <Notification />,
    },
    {
        path: WebUrl._URL_DOWNLINE,
        exact: true,
        title: "Downline",
        authRequired: true,
        component: () => <Downline />,
    },
    {
        path: WebUrl._URL_PROGRESS_COMM_RATE,
        exact: true,
        title: "Products Commission Rate",
        authRequired: true,
        component: () => <ProgressCommRate />,
    },
    {
        path: WebUrl._URL_EDIT_DOWNLINE,
        exact: true,
        title: "Edit Downline",
        authRequired: true,
        component: () => <EditDownlineDetails />,
    },
    {
        path: WebUrl._URL_DOWNLINE_GROUP_DETAIL,
        exact: true,
        title: "Downline Group Detail",
        authRequired: true,
        component: () => <DownlineGroupDetail />,
    },
    {
        path: WebUrl._URL_Edit_Downline_Group_Detail,
        exact: true,
        title: "Downline Group Detail",
        authRequired: true,
        component: () => <EditDownlineGroupDetail />,
    },
    {
        path: WebUrl._URL_KPI,
        exact: true,
        title: "KPI",
        authRequired: true,
        component: () => <Kpi />,
    },
    {
        path: WebUrl._URL_REPORT,
        exact: true,
        title: "Report",
        authRequired: true,
        component: () => <Report />,
    },
    {
        path: WebUrl._URL_GAME_RECORD,
        exact: true,
        title: "Game Record",
        authRequired: true,
        component: () => <GameRecordUG embedded={false} variant="record" autoLoad={false} />,
    },
    {
        path: WebUrl._URL_WALLET_STATEMENT,
        exact: true,
        title: "Wallet Statement",
        authRequired: true,
        component: () => <WalletStatement />,
    },
    {
        path: WebUrl._URL_ROLLOVER_STATEMENT,
        exact: true,
        title: "Rollover Statement",
        authRequired: true,
        component: () => <RolloverStatement />,
    },
    {
        path: WebUrl._URL_REWARDS,
        exact: true,
        title: "Rewards",
        authRequired: true,
        component: () => <Rewards />,
    },
    {
        path: WebUrl._URL_REWARD_HISTORY,
        exact: true,
        title: "Reward History",
        authRequired: true,
        component: () => <RewardHistory />,
    },
    {
        path: WebUrl._URL_REWARDS_TNC,
        exact: true,
        title: 'Rewards Terms & Conditions',
        authRequired: true,
        component: () => <RewardsTnC />
    },
    {
        path: WebUrl._URL_REGISTER,
        exact: true,
        title: "Register",
        component: () => <RegisterNew />,
    },
    {
        path: WebUrl._URL_REGISTER_SUCCESS,
        exact: true,
        title: "Registration Success",
        authRequired: false,
        component: () => <RegisterSuccess />,
    },
    {
        path: WebUrl._URL_BONUS_REPORT,
        exact: true,
        title: "Bonus Report",
        authRequired: true,
        component: () => <BonusReport />,
    },
    {
        path: WebUrl._URL_INTERNAL_TRANSFER_REPORT,
        exact: true,
        title: "Internal Transfer Report",
        authRequired: true,
        component: () => <InternalTransferReport />,
    },
    {
        path: WebUrl._URL_ACCOUNT,
        exact: true,
        title: "Account",
        authRequired: true,
        component: () => <Account />,
    },
    {
        path: WebUrl._URL_SETTINGS,
        exact: true,
        title: "Settings",
        authRequired: true,
        component: () => <Settings />,
    },
    {
        path: WebUrl._URL_TERMS_AND_CONDITIONS,
        exact: true,
        title: "Terms and Conditions",
        authRequired: true,
        component: () => <Terms />,
    },
    {
        path: WebUrl._URL_ABOUT_US,
        exact: true,
        title: "About Us",
        authRequired: false,
        component: () => <About />,
    },
    {
        path: WebUrl._URL_PRIVACY_POLICY,
        exact: true,
        title: "Privacy Policy",
        authRequired: false,
        component: () => <About />,
    },
    {
        path: WebUrl._URL_AFFILIATE_PARTNER_PROGRAM,
        exact: true,
        title: "Affiliate Partner Program",
        authRequired: false,
        component: () => <About />,
    },
    {
        path: WebUrl._URL_RESPONSIBLE_GAMBLING,
        exact: true,
        title: "Responsible Gambling",
        authRequired: false,
        component: () => <Terms />,
    },
    {
        path: WebUrl._URL_VIP,
        exact: true,
        title: "VIP",
        authRequired: true,
        component: () => <VipEvent />,
    },
    {
        path: WebUrl._URL_SUMMARY_DOWNLINE,
        exact: true,
        title: "Summary Downline",
        authRequired: true,
        component: () => <SummaryDownline />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE,
        exact: true,
        title: "Help Centre",
        authRequired: false,
        component: () => <HelpCentre />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_CATEGORY,
        exact: true,
        title: "Help Centre Category",
        authRequired: false,
        component: () => <HelpCentreCategory />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_SUB_CATEGORY,
        exact: true,
        title: "Help Centre Sub Category",
        authRequired: false,
        component: () => <HelpCentreSubCategory />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_FAQ,
        exact: true,
        title: "Help Centre Faq",
        authRequired: false,
        component: () => <HelpCentreFaq />,
    },
    {
        path: WebUrl._URL_REFERRAL,
        exact: true,
        title: "Referral",
        authRequired: true,
        component: () => <Referral />,
    },
    {
        path: WebUrl._URL_REFERRAL_CODE,
        exact: true,
        title: "Referral Code",
        authRequired: true,
        component: () => <ReferralCode />,
    },
    {
        path: WebUrl._URL_REFERRAL_EDIT,
        exact: true,
        title: "Referral Edit",
        authRequired: true,
        component: () => <ReferralEdit />,
    },
    {
        path: WebUrl._URL_DOWNLOAD_APP,
        exact: true,
        title: "Download App",
        authRequired: true,
        component: () => <DownloadApp />,
    },
    {
        path: WebUrl._URL_VIDEO_TUTORIAL,
        exact: true,
        title: "Video Tutorial",
        authRequired: true,
        component: () => <VideoTutorial />,
    },
    {
        path: WebUrl._URL_NOTIFICATION_DETAIL,
        exact: true,
        title: "Notification Detail",
        authRequired: true,
        component: () => <NotificationDetail />,
    },
    {
        path: WebUrl._URL_4D_RESULT,
        exact: true,
        title: "4D Result",
        authRequired: false,
        component: () => <Result />,
    },
    {
        path: WebUrl._URL_CONTACT_US,
        exact: true,
        title: "Contact Us",
        authRequired: false,
        component: () => <ContactUs />,
    },
    {
        path: WebUrl._URL_LIVE_CHAT,
        exact: true,
        title: 'Live Chat',
        component: () => <LiveChatPage />
    },
    {
        path: WebUrl._URL_GAME_LIST,
        exact: true,
        title: "Game Sort Selection",
        authRequired: false,
        component: () => <GameList />,
    },
    {
        path: WebUrl._URL_CLAIM_HISTORY,
        exact: true,
        title: "Claim History",
        authRequired: true,
        component: () => <ClaimHistory />,
    },
    {
        path: WebUrl._URL_SLOT,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Slots")} />,
    },
    {
        path: WebUrl._URL_ESPORT,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("eSports")} />,
    },
    {
        path: WebUrl._URL_RNG,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("RNG")} />,
    },
    {
        path: WebUrl._URL_CONNECT,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Connect")} />,
    },
    {
        path: WebUrl._URL_LOTTERY,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Lottery")} />,
    },
    {
        path: WebUrl._URL_POKER,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Poker")} />,
    },
    {
        path: WebUrl._URL_SPORT,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Sports")} />,
    },
    {
        path: WebUrl._URL_CASINO,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("Casino")} />,
    },
    {
        path: WebUrl._URL_RICHWIN_ADMIN,
        exact: true,
        title: "Richwin Admin",
        authRequired: true,
        component: () => <RichwinAdmin />,
    },
    {
        path: WebUrl._URL_COMMISSION_HISTORY,
        exact: true,
        title: "Commission History",
        authRequired: true,
        component: () => <CommissionHistory />,
    },
    {
        path: WebUrl._URL_UNCLAIM_COMMISSION_HISTORY,
        exact: true,
        title: "Unclaim Commission History",
        authRequired: true,
        component: () => <UnclaimCommissionHistory />,
    },
    {
        path: WebUrl._URL_WALLET_TRANSFER_HISTORY,
        exact: true,
        title: "Wallet Transfer History",
        authRequired: true,
        component: () => <WalletTransferHistory />,
    },
    {
        path: WebUrl._URL_DEPOSIT_RECORD,
        exact: true,
        title: "Deposit Record",
        authRequired: true,
        component: () => <DepositRecord />,
    },
    {
        path: WebUrl._URL_WITHDRAWAL_RECORD,
        exact: true,
        title: "Withdrawal Record",
        authRequired: true,
        component: () => <WithdrawalRecord />,
    },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION,
        exact: true,
        title: "Loyalty Redemption",
        authRequired: true,
        component: () => <LoyaltyRedemption />,
    },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION_HISTORY,
        exact: true,
        title: "Loyalty Redemption History",
        authRequired: true,
        component: () => <LoyaltyRedemptionHistory />,
    },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION_TNC,
        exact: true,
        title: "Loyalty Redemption TnC",
        authRequired: true,
        component: () => <LoyaltyRedemptionTnC />,
    },
    //{
    //    path: WebUrl._URL_UNCLAIM_LOYALTY_POINTS,
    //    exact: true,
    //    title: "Unclaim Loyalty Points",
    //    authRequired: true,
    //    component: () => <UnclaimLoyaltyPoints />,
    //},
    {
        path: WebUrl._URL_LOYALTY_POINTS_HISTORY,
        exact: true,
        title: "Loyalty Points History",
        authRequired: true,
        component: () => <LoyaltyPointsHistory />,
    },
    {
        path: WebUrl._URL_LOYALTY_VOUCHER_DETAILS,
        exact: true,
        title: "Loyalty Voucher Details",
        authRequired: true,
        component: () => <LoyaltyVoucherDetails />,
    },
    {
        path: WebUrl._URL_COCK_FIGHTING,
        exact: true,
        component: () => <Redirect to={WebUrl.providerLobbyUrl("CockFighting")} />,
    },
    {
        path: WebUrl._URL_DEPOSIT_BONUS_HISTORY,
        exact: true,
        title: "Deposit Bonus History",
        authRequired: true,
        component: () => <DepositBonusHistory />,
    },
    {
        path: WebUrl._URL_DAILY_CHECK_IN,
        exact: true,
        title: "Daily Check In",
        authRequired: true,
        component: () => <DailyCheckIn />,
    },
    {
        path: WebUrl._URL_PROMOTION,
        exact: true,
        title: "Promotion Lobby",
        component: () => <Promotion />,
    },
    {
        path: WebUrl._URL_MEMBER_PRODUCT_RATE_DETAIL,
        exact: true,
        title: "Product Rate %",
        component: () => <MemberProductRateDetail />,
    },
    {
        path: WebUrl._URL_GAME_PROVIDER_LIST,
        exact: true,
        title: "Game Provider",
        component: () => <GameProviderList />,
    },
    {
        path: WebUrl._URL_PUSAT_INFO,
        exact: true,
        title: "Pusat Info",
        component: () => <PusatInfo />,
    },
    {
        path: WebUrl._URL_FAQ,
        exact: true,
        title: "Faq",
        component: () => <Terms />,
    },
    {
        path: WebUrl._URL_HOW_TO_PLAY,
        exact: true,
        title: "How To Play",
        component: () => <Terms />,
    },
    {
        path: WebUrl._URL_REGISTER_NEW,
        exact: true,
        title: "Register",
        component: () => <RegisterNew />,
    },
    {
        path: WebUrl._URL_MY_PROMO,
        exact: true,
        title: "My Promo",
        component: () => <MyPromo />,
    },
    {
        path: WebUrl._URL_STATEMENT,
        exact: true,
        title: "Statement",
        authRequired: true,
        component: () => <Statement />,
    },
    {
        path: WebUrl._URL_DEPOSIT_RECORD_UG,
        exact: true,
        title: "Deposit Record UG",
        authRequired: true,
        component: () => <DepositRecordUG />,
    },
    {
        path: WebUrl._URL_WITHDRAWAL_RECORD_UG,
        exact: true,
        title: "Withdrawal Record UG",
        authRequired: true,
        component: () => <WithdrawalRecordUG />,
    },
    {
        path: WebUrl._URL_TRANSFER_RECORD_UG,
        exact: true,
        title: "Transfer Record UG",
        authRequired: true,
        component: () => <TransferRecordUG />,
    },
    {
        path: WebUrl._URL_CONTENT_REFERRAL,
        exact: true,
        title: "Referral",
        component: () => <Terms />,
    },
    {
        path: WebUrl._URL_LAST_TRANSACTION,
        exact: true,
        title: "Last 5 Transaction",
        authRequired: true,
        component: () => <LastTransaction />,
    },
    {
        path: WebUrl._URL_PROVIDER_LOBBY,
        exact: true,
        title: "Game Lobby",
        component: () => <ProviderLobby />,
    },
    {
        path: WebUrl._URL_SPIN_WHEEL,
        exact: true,
        title: "Spin Wheel",
        component: () => <SpinWheel />,
    },
    {
        path: WebUrl._URL_CONGRATS,
        exact: true,
        title: "Congrats",
        component: () => <Congrats />,
    },
    {
        path: WebUrl._URL_INACTIVE_DOWNLINE,
        exact: true,
        title: "Congrats",
        component: () => <InactiveDownlines />,
    },
    {
        path: WebUrl._URL_TOTAL_COMMISION,
        exact: true,
        title: "Total Commision and Reward",
        component: () => <TotalCommAndReward />,
    },
    {
        path: WebUrl._URL_MEMBER_BENEFIT_PAGE ,
        exact: true,
        title: "Member Benefit",
        component: () => <MemberBenefit />,
    },
];
